module.exports = __webpack_public_path__ + "images/emoji/o2.4811a2181e3bf5f2f949.png";